// extracted by mini-css-extract-plugin
module.exports = {"hotelDescription":"hotel_info_section_hotelDescription__2jSMJ","hotelTitleSection":"hotel_info_section_hotelTitleSection__1kBEg"};